import { AlternativePrice, Price } from 'src/types';

export enum PriceDisplayEnum {
  PRICE = 'price-excludes-shipping',
  PRICE_INCLUDES_SHIPPING = 'price_includes_shipping',
}

export type PriceDisplay =
  | PriceDisplayEnum.PRICE
  | PriceDisplayEnum.PRICE_INCLUDES_SHIPPING;

export enum SortOptionEnum {
  PRICE = 'price',
  PRICEANDSTOCKSTATUS = 'price_in_stock',
}

export type SortOption =
  | SortOptionEnum.PRICE
  | SortOptionEnum.PRICEANDSTOCKSTATUS;

// Note: Copy any changes here to config/types/market
export enum FilterTypeEnum {
  PRICES_INC_SHIPPING = 'prices_inc_shipping',
  IN_STOCK = 'in_stock',
  FEATURED_SHOP = 'featured_shop',
  AUTHORIZED_DEALER = 'authorized_dealer',
  PICKUP_ONLY = 'pickup_only',
  INTERNATIONAL = 'international',
  NOT_FOR_SALE = 'not_for_sale',
  VARIANT_SIZE = 'variant_size',
  CONDITION = 'condition',
}

// Note: Copy any changes here to config/types/market
export type FilterType =
  | FilterTypeEnum.PRICES_INC_SHIPPING
  | FilterTypeEnum.IN_STOCK
  | FilterTypeEnum.FEATURED_SHOP
  | FilterTypeEnum.AUTHORIZED_DEALER
  | FilterTypeEnum.PICKUP_ONLY
  | FilterTypeEnum.INTERNATIONAL
  | FilterTypeEnum.NOT_FOR_SALE
  | FilterTypeEnum.VARIANT_SIZE
  | FilterTypeEnum.CONDITION;

export enum FilterUIPlacementEnum {
  PRODUCT_HEADER,
  FILTER_MENU,
  OFFERLIST_HEADER,
}

export enum FilterUISubPlacementEnum {
  SHOW_ONLY,
  ADDITIVE,
}

export type FilterUISubPlacement =
  | FilterUISubPlacementEnum.SHOW_ONLY
  | FilterUISubPlacementEnum.ADDITIVE;

export type FilterUIPlacement =
  | FilterUIPlacementEnum.PRODUCT_HEADER
  | FilterUIPlacementEnum.FILTER_MENU
  | FilterUIPlacementEnum.OFFERLIST_HEADER;

export type FilterOffer = Price | AlternativePrice | null | undefined;

export type FilterSelection = string[];

export interface IFilter {
  active: boolean;
  label: string;
  type: FilterType;
  placement: FilterUIPlacement;
  subPlacement?: FilterUISubPlacement;
  filterFn: (offer: FilterOffer, selection?: FilterSelection) => boolean;
  filterAlternativeOffers: boolean;
  selection?: FilterSelection;
  initialSelection?: FilterSelection;
  missingInfoFn?: (offer: FilterOffer) => boolean; // Provide to keep offers with missing info
  additive?: boolean;
  treatUnfeaturedAsMissingInfo?: boolean;
  hidden?: boolean;
}
